import { render, staticRenderFns } from "./CommentsCount.vue?vue&type=template&id=b93391bc"
import script from "./CommentsCount.vue?vue&type=script&lang=ts"
export * from "./CommentsCount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports